import config from "lib/fr-config";
import * as Sentry from "@sentry/browser";

const ENABLE_SENTRY = process.env.NODE_ENV === "production";

const main = (() => {
  let sentryObj = undefined;

  const initSentry = () => {
    if (!ENABLE_SENTRY) return null;
    if (sentryObj) return null;
    Sentry.init({
      dsn: config.sentry.DSN,
      release: `frontend@${config.version}`
    });
    sentryObj = Sentry;

    _setUserInfo({});
  };

  const _setUserInfo = ({ username, viewerLocation }) => {
    if (!ENABLE_SENTRY) return null;
    if (!sentryObj) return null;

    const tagUsername = username || null;
    const tagUserType = username ? "member" : "guest";

    sentryObj.configureScope(scope => {
      scope.setTag("tag:username", tagUsername);
      scope.setTag("tag:user-type", tagUserType);
      scope.setTag("tag:device-location", viewerLocation);
    });
  };

  const changeSentryConfig = ({ username, viewerLocation }) => {
    _setUserInfo({ username, viewerLocation });
  };

  const _sendError = error => {
    const { errorValue } = error;

    if (ENABLE_SENTRY) {
      if (!sentryObj) return null;

      sentryObj.withScope(scope => {
        sentryObj.setContext("Error Value", errorValue);
        sentryObj.captureException(error);
      });
    } else {
      console.error("Captured Error ==>>", error);
      console.error("errorValue ==>>", errorValue);
    }
  };

  /**
   * error.errorValue = [객체] 에러 발생 원인 추적위한 당시 변수의 key,value pair
   */
  const sendError = error => {
    let errObj = error;
    if (typeof error !== "object") {
      console.error("wrong error input");
      errObj = Error(errObj);
    }

    _sendError(errObj);
  };

  const sendMessage = message => {
    if (!sentryObj) return null;
    sentryObj.captureMessage(message);
  };

  return { initSentry, changeSentryConfig, sendError, sendMessage };
})();

export const { initSentry, changeSentryConfig, sendError, sendMessage } = main;
